var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_5870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0104 5.07178V8.54834H14.5715L10.6082 17.8192H7.375V21.2957H16.6458V17.8192H14.0848L18.048 8.54834H21.2812V5.07178H12.0104Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_5870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.8125,
    height: 27.8125,
    fill: "white",
    transform: "translate(0.421875 0.4375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalic);
export default __webpack_public_path__ + "static/media/italic.53014492ed54986c1cbe7e7bb5d51d07.svg";
export { ForwardRef as ReactComponent };